












import Vue from 'vue';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default Vue.extend({
    props: ['page', 'type'],
    components: {
        swiper,
        swiperSlide
    },
    created() {
        window.FRSToolV3.getConfig({ page: this.page, type: this.type }).then((res: any) => {
            (this as any).adBannerData = res.result;
            if (res.result.length < 2) {
                (this as any).swiperOption.loop = false;
                (this as any).swiperOption.autoplay = {};
            }
        });
        if (window.innerWidth < 768) {
            (this as any).desktop = false;
        } else {
            (this as any).desktop = true;
        }
    },
    data() {
        return {
            desktop: true,
            adBannerData: [],
            adBannerOption: {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 2500
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        };
    },
    computed: {
        swiper() {
            return (this as any).$refs.adBannerSwiper.swiper;
        }
    },
    methods: {
        swiperMouseOn() {
            (this as any).swiper.autoplay.stop();
        },
        swiperMouseOff() {
            (this as any).swiper.autoplay.start();
        },
        GAcode(el: string) {
            if (typeof window.ActionAnalysisV2 !== 'undefined' && typeof el !== 'undefined') {
                window.ActionAnalysisV2.actClk('Banner_' + el);
            }
        }
    }
});
